"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.payment.confirmed': 'Płatność Potwierdzona',
    'route.payment.list': 'Płatności',
    'route.payment.preview': 'Szczegóły Płatności',
};
